export default __webpack_public_path__ + "static/media/progress-circle-4.792cbcd5.svg";